export default {
  data() {
    return {
      id: this.$attrs.id
    };
  },

  created() {
    if (this.id) return;

    this.id =
      "id-" +
      Array(6)
        .fill()
        .map(() => Math.floor(36 * Math.random()).toString(36))
        .join("");
  }
};
